/* * 绘制图形 * @module components/drawTool/drawTool * @desc 用于图形绘制 * @author ss *
@date 2020年8月31日 */
<template>
  <div id="drawsTool">
    <Row style="margin-top:10px;">
      <Col span="10">
        填充色设置：
        <ColorPicker alpha size="small"  @on-change="styleChange($event,'fC')" v-model="drawGrid.fillColor" />
      </Col>
      <Col span="8">
        边框色：
        <ColorPicker size="small" @on-change="styleChange($event,'bC')" v-model="drawGrid.borderColor" />
      </Col>
      <Col span="6">
        边宽：
        <InputNumber
          type="number"
          size="small"
          :max="50"
          :min="1"
          v-model.number="drawGrid.borderWidth"
        @on-change="styleChange($event,'bW')"
          style="width: 44px"
        />
      </Col>
    </Row>
    <Row>
      <Col span="4">基本图形:</Col>
      <Col span="20">
        <div class="iconstyle" @click="drawArea('Point')">
          <img src="../../../static/image/analysis/点/point_un.png" />
          <div class="text">点</div>
        </div>
        <div class="iconstyle" @click="drawArea('LineString')">
          <img src="../../../static/image/analysis/线/line_un.png" />
          <div class="text">线</div>
        </div>
        <div class="iconstyle" @click="drawArea('Box')">
          <img src="../../../static/image/analysis/面/fill_un.png" />
          <div class="text">面</div>
        </div>
        <div class="iconstyle" @click="drawArea('Circle')">
          <img src="../../../static/image/analysis/异形/poly_un.png" />
          <div class="text">圆</div>
        </div>
        <div class="iconstyle" @click="drawArea('Polygon')">
          <img src="../../../static/image/analysis/异形/poly_un.png" />
          <div class="text">异形</div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col span="4">箭头:</Col>
      <Col span="20">
        <div class="iconstyle" @click="drawArrow('SimpleArrow')">
          <img src="../../../static/maptool/draw/jdjt.png" />
          <div class="text">简单箭头</div>
        </div>
        <div class="iconstyle" @click="drawArrow('DoubleArrow')">
          <img src="../../../static/maptool/draw/sjt.png" />
          <div class="text">双箭头</div>
        </div>
        <div class="iconstyle" @click="drawArrow('StraightArrow')">
          <img src="../../../static/maptool/draw/zjt.png" />
          <div class="text">直箭头</div>
        </div>
        <div class="iconstyle" @click="drawArrow('SingleLineArrow')">
          <img src="../../../static/maptool/draw/djtzx.png" />
          <div class="text">单线箭头</div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col span="4">旗帜:</Col>
      <Col span="20">
        <div class="iconstyle" @click="drawArrow('TriangleFlag')">
          <img src="../../../static/maptool/draw/sjq.png" />
          <div class="text">三角旗</div>
        </div>
        <div class="iconstyle" @click="drawArrow('RectFlag')">
          <img src="../../../static/maptool/draw/jxq.png" />
          <div class="text">矩形旗</div>
        </div>
        <div class="iconstyle" @click="drawArrow('CurveFlag')">
          <img src="../../../static/maptool/draw/blq.png" />
          <div class="text">波浪旗</div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col span="4">指北针:</Col>
      <Col span="20">
        <div class="iconstyle" @click="drawArrow('ArrowCross')">
          <img src="../../../static/maptool/draw/szzbz.png" />
          <div class="text">十字</div>
        </div>

        <div class="iconstyle" @click="drawArrow('CircleClosedangle')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">圆形尖角</div>
        </div>
        <div class="iconstyle" @click="drawArrow('Closedangle')">
          <img src="../../../static/maptool/draw/sxjjzbz.png" />
          <div class="text">尖角</div>
        </div>
        <div class="iconstyle" @click="drawArrow('DoubleClosedangle')">
          <img src="../../../static/maptool/draw/sxjjzbz.png" />
          <div class="text">双向尖角</div>
        </div>
        <div class="iconstyle" @click="drawArrow('Fourstar')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">四角</div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col span="4">&nbsp;</Col>
      <Col span="20">
        <div class="iconstyle" @click="drawArrow('Rhombus')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">菱形</div>
        </div>
        <div class="iconstyle" @click="drawArrow('SameDirectionClosedangle')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">同向尖角</div>
        </div>
        <div class="iconstyle" @click="drawArrow('Triangle')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">三角</div>
        </div>
        <div class="iconstyle" @click="drawArrow('Vane')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">风向标</div>
        </div>
      </Col>
    </Row>
    <Row>
      <Col span="4">集结区</Col>
      <Col span="20">
        <div class="iconstyle" @click="drawArrow('Bezier')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">任意区</div>
        </div>
        <div class="iconstyle" @click="drawArrow('AssemblyArea')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">集结区</div>
        </div>
        <div class="iconstyle" @click="drawArrow('BezierLine')">
          <img src="../../../static/maptool/draw/zbz.png" />
          <div class="text">光滑曲线</div>
        </div>
      </Col>
    </Row>
    <div class="del-icon">
      <div class="iconstyle" @click="drawArea('delete')">
        <img src="../../../static/image/analysis/删除/del_un.png" />
        <div class="text">删除</div>
      </div>
    </div>
  </div>
</template>
<script>
import drawTool from './drawTool';
export default drawTool;
</script>
<style lang="less" scoped>
#drawsTool {
  /deep/ .ivu-row {
    height: 57px;
  }
  .iconstyle {
    float: left;
    width: 54px;
    text-align: center;
    list-style: none;
    cursor: pointer;
    height: 20px;
    color: #5c6b77;
    transition: all 0.2s ease;
    position: relative;
    img {
      display: inline-block;
      text-align: center;
    }
    .text {
      text-align: center;
      font-size: 12px;
      width: auto;
      line-height: 14px;
    }
  }
  .del-icon {
    position:absolute;
    right: 5px;
    bottom: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/drawTool/drawTool.vue